module.exports = __webpack_public_path__ + "img/art_collection.d63c20f5.png";